import React from 'react'
import Quotation from '/img/svg/quotation'
import Image from '/js/views/shared/components/contentParticles/image'

class HighlightQuote extends React.Component {
  render() {
    const { content, theme } = this.props

    return (
      <blockquote
        className="text-center w-full flex flex-col items-center"
        data-label="highlight-quote"
      >
        {content.images && <Image content={content} />}

        <p className="leading-normal font-bold italic mb-15 w-full">
          {content.texts.quote}
        </p>
        <footer className="flex flex-col items-center">
          <div aria-hidden="true" className={`mb-15 ${theme.textColor}`}>
            <Quotation />
          </div>
          {content.texts.name && (
            <p
              className={`text-18 font-condensed uppercase ${theme.textColor}`}
            >
              {content.texts.name}
            </p>
          )}
          <p className="text-14 font-condensed uppercase">
            {content.texts.company && <span>{content.texts.company}</span>}
            {content.texts.company && content.texts.title && ', '}
            {content.texts.title && <span>{content.texts.title}</span>}
          </p>
        </footer>
      </blockquote>
    )
  }
}

export default HighlightQuote
